// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cluster{--size:40px;align-items:center;display:grid;grid-template-columns:40px;grid-template-columns:var(--size);justify-items:center;place-items:center}.cluster>*{grid-column:1;grid-row:1}.cluster img{height:var(--size)}.cluster span{font-size:1.125rem;line-height:1.5rem;position:relative;z-index:10;--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
